import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';

interface IBestSellerRoute {
    route: { depPort: string; arrPort: string; ordered: string[] };
    reservation: number;
    lastYearReservation: number;
    topSellerAgent: string;
    revenue: number;
}

@Component({
    selector: 'app-best-seller-route-panel',
    imports: [CommonModule],
    templateUrl: './best-seller-route-panel.component.html',
    styleUrl: './best-seller-route-panel.component.scss'
})
export class BestSellerRoutePanelComponent {
    loading = input<boolean>(false);
    bestSellerRouteData = input<IBestSellerRoute[]>();

    readonly topRoutes = computed(() => {
        const data = this.bestSellerRouteData();
        if (!data || data.length === 0) return [];
        return [...data].sort((a, b) => b.reservation - a.reservation).slice(0, 5);
    });

    readonly maxReservation = computed(() => {
        const data = this.topRoutes();
        if (data.length === 0) return 1;
        return Math.max(...data.map((r) => r.reservation));
    });

    readonly topRoute = computed(() => {
        const data = this.topRoutes();
        if (data.length === 0) return null;
        return data[0];
    });

    getBarWidth(reservation: number): number {
        return Math.round((reservation / this.maxReservation()) * 100);
    }
}
